import { z } from 'zod';
import { codeSchema } from '../code.js';
/** SLA policy. Values are configuration, never code. */
export const escalationRuleSchema = z.object({
    /** Negative = before due; positive = after due. Minutes. */
    offsetMinutes: z.number().int(),
    /**
     * WARNING: aviso al responsable. NOTIFY_SUPERVISOR: aviso a su superior en la cadena de mando.
     * ESCALATE: marca el caso como escalado y avisa al superior. REASSIGN: reasigna. Sin superior, avisa a los administradores.
     */
    action: z.enum(['WARNING', 'NOTIFY_SUPERVISOR', 'ESCALATE', 'REASSIGN']),
    notifyAssignee: z.boolean().default(true),
});
export const slaPolicySchema = z.object({
    code: codeSchema(60),
    name: z.string().min(1).max(120),
    amount: z.number().int().min(1),
    unit: z.enum(['MINUTES', 'HOURS', 'DAYS']),
    timeMode: z.enum(['CALENDAR', 'BUSINESS']).default('BUSINESS'),
    calendarCode: z.string().optional(),
    escalations: z.array(escalationRuleSchema).default([]),
    /** Optional selectors so a policy can apply by case type/channel/priority when the node has none. */
    appliesTo: z
        .object({
        caseTypeCodes: z.array(z.string()).optional(),
        channels: z.array(z.string()).optional(),
        priorities: z.array(z.string()).optional(),
    })
        .optional(),
});
export const businessCalendarSchema = z.object({
    code: codeSchema(60),
    name: z.string().min(1),
    timezone: z.string().default('America/Bogota'),
    /** 0=Sunday … 6=Saturday, each with optional working window. */
    workingDays: z
        .array(z.object({ weekday: z.number().int().min(0).max(6), start: z.string().regex(/^\d{2}:\d{2}$/), end: z.string().regex(/^\d{2}:\d{2}$/) }))
        .min(1),
    holidays: z.array(z.string().regex(/^\d{4}-\d{2}-\d{2}$/)).default([]),
});
/** Festivos de Colombia y años que se cargan de una vez: del paquete de la suite (`@xiltrion/calendario`). */
export { COLOMBIAN_HOLIDAY_YEARS_AHEAD, colombianHolidays, colombianHolidaysBetween } from '@xiltrion/calendario';
export const SlaInstanceStatus = {
    RUNNING: 'RUNNING',
    WARNING: 'WARNING',
    BREACHED: 'BREACHED',
    MET: 'MET',
    CANCELLED: 'CANCELLED',
    PAUSED: 'PAUSED',
};
/** Formats remaining time the way the UI must show it. */
export function describeDue(dueAt, now = new Date()) {
    const diff = dueAt.getTime() - now.getTime();
    const abs = Math.abs(diff);
    const d = Math.floor(abs / 86_400_000);
    const h = Math.floor((abs % 86_400_000) / 3_600_000);
    const m = Math.floor((abs % 3_600_000) / 60_000);
    const parts = d > 0 ? `${d}d ${h}h` : h > 0 ? `${h}h ${m}m` : `${m}m`;
    if (diff < 0)
        return { text: `Vencida hace ${parts}`, tone: 'overdue' };
    if (diff < 4 * 3_600_000)
        return { text: `Vence en ${parts}`, tone: 'warning' };
    return { text: `Vence en ${parts}`, tone: 'ok' };
}
//# sourceMappingURL=sla.js.map